module.exports = __webpack_public_path__ + "img/1557614106793549825.bc7252b2.png";